import { Stack } from "@mui/material";
import { EllipsisTooltip } from "../../ui/CustomTooltip";
import {
  AlertInCircleIcon,
  CheckInCircleIcon,
  CheckInEmptyCircleIcon,
  DragFieldIcon,
  InfuseDataIcon,
  UserDataIcon,
} from "../../images";
import { TextWrapper } from "./TextWrapper";
import { isMoreThanTwoWeeksFromNow } from "../../../utils/isMoreThanTwoWeeksFromNow";
import { DATA_TYPES } from "../../../constant";
import { ReactNode } from "react";

const iconMap: Record<string, JSX.Element> = {
  [DATA_TYPES.user]: <UserDataIcon />,
  [DATA_TYPES.infuse]: <InfuseDataIcon />,
};

const ActivatedMemberWrapper = ({
  isActivated,
  children,
}: {
  isActivated?: boolean;
  children: ReactNode;
}) => {
  return (
    <Stack
      sx={{
        position: "relative",
      }}
    >
      {children}
      {isActivated && (
        <div
          style={{
            position: "absolute",
            right: -2,
            bottom: 1,
            border: "2px solid white",
            borderRadius: "50%",
            backgroundColor: "white",
          }}
        >
          <CheckInCircleIcon width={"10px"} height={"10px"} />
        </div>
      )}
    </Stack>
  );
};

export const DataSourceBodyCell = ({
  value,
  data_source,
  minWidth,
  maxWidth,
  justifyContent = "space-between",
  gap = "8px",
  isHighlighted,
  warning_tooltip,
  linkedin_updated_at,
  title,
  isRoleEdit,
  is_hidden,
  is_activated,
  withTitle,
}: {
  value: string;
  data_source: string;
  minWidth: string;
  maxWidth: string;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
  gap?: string;
  isHighlighted: boolean;
  warning_tooltip?: string;
  linkedin_updated_at?: string;
  title?: string;
  isRoleEdit?: boolean;
  is_hidden: boolean;
  is_activated?: boolean;
  withTitle?: boolean;
}) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={justifyContent}
      width="100%"
      gap={gap}
      padding={`0 16px 0 ${isRoleEdit ? "4px" : " 16px"}`}
    >
      <Stack
        flexDirection="row"
        gap="8px"
        alignItems="center"
        overflow="hidden"
      >
        {isRoleEdit && <DragFieldIcon />}
        <Stack overflow="hidden">
          <Stack flexDirection="row" gap="8px" alignItems="center">
            <EllipsisTooltip hide={false} tooltip={data_source} align="center">
              <ActivatedMemberWrapper isActivated={is_activated}>
                {iconMap[data_source] || iconMap[DATA_TYPES.user]}
              </ActivatedMemberWrapper>
            </EllipsisTooltip>
            {is_hidden ? (
              <Stack flexDirection={"row"} paddingRight={"8px"}>
                <TextWrapper
                  text={value}
                  isHighlighted={isHighlighted}
                  is_activated={is_activated}
                />
                <TextWrapper
                  text={"Hidden"}
                  isHighlighted={isHighlighted}
                  style={{
                    filter: "blur(4px)",
                    borderRadius: "12px",
                  }}
                />
              </Stack>
            ) : (
              <EllipsisTooltip align="center">
                <TextWrapper
                  text={value}
                  isHighlighted={isHighlighted}
                  is_activated={is_activated}
                />
              </EllipsisTooltip>
            )}
          </Stack>
          {withTitle && (
            <Stack paddingX={"8px"}>
              {is_hidden ? (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#1F2932",
                    ...(is_hidden && { filter: "blur(4px)" }),
                  }}
                >
                  Hidden Manager Example (HME).
                </span>
              ) : (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#1F2932",
                  }}
                >
                  {title}
                </span>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>

      {warning_tooltip && (
        <EllipsisTooltip tooltip={warning_tooltip} hide={false}>
          <AlertInCircleIcon />
        </EllipsisTooltip>
      )}
      {linkedin_updated_at && !warning_tooltip && (
        <EllipsisTooltip
          hide={false}
          tooltip={
            isMoreThanTwoWeeksFromNow(linkedin_updated_at)
              ? "Updated more than 2 weeks ago"
              : "Updated recently"
          }
        >
          <CheckInEmptyCircleIcon
            color={
              isMoreThanTwoWeeksFromNow(linkedin_updated_at)
                ? "#C3C3C3"
                : undefined
            }
          />
        </EllipsisTooltip>
      )}
    </Stack>
  );
};
